<template>
  <div>
    <!-- Filters -->
    <div class="table-filters-desktop no_mobile">
      <div class="row-tb-filters flex items-start">
        <!-- Filters desktop -->
        <h2 class="title flex items-start">
          <img src="/assets/img/svg/filters.svg" alt="" />
          סינונים:
        </h2>
        <div class="tb-filters-in is--fit flex">
          <div v-if="!isShowMoreActive" class="tb-filters-in flex">
            <span
              v-for="(col, i) in defaultColumns"
              :key="i"
              class="tb-filter pointer"
              :class="{ active: getIsColumnActive(col.name) }"
              @click="toggleColumn(col.name)"
            >
              {{ col.hebrewName }}
            </span>
          </div>
          <div v-else class="tb-filters-in flex">
            <span
              v-for="(col, q) in columns"
              :key="q"
              class="tb-filter pointer"
              @click="toggleColumn(col.name)"
              :class="{ active: getIsColumnActive(col.name) }"
            >
              {{ col.hebrewName }}
            </span>
          </div>
          <a
            class="show-more-filters"
            href="javascript:void(0)"
            @click="isShowMoreActive = !isShowMoreActive"
          >
            <span v-if="!isShowMoreActive">+ עוד סינונים</span>
            <span v-else>- פחות סינונים</span>
          </a>
        </div>
        <div>
          <a
            href="javascript:void(0)"
            v-if="showClearButton"
            class="clear-filters flex"
            @click="resetState"
          >
            <img src="/assets/img/svg/trash.svg" alt="" />
            ניקוי סינונים
          </a>
        </div>
      </div>
    </div>

    <!-- Filters mobile -->
    <div class="table-filters-mobile mobile_only">
      <div class="flex">
        <button class="m-open-filters flex" @click="openFiltersPopup">
          <img src="/assets/img/svg/filters.svg" alt="" />
          סינונים
        </button>
        <a
          href="javascript:void(0)"
          v-if="showClearButton"
          class="clear-filters flex"
          @click="resetState"
        >
          <img src="/assets/img/svg/trash.svg" alt="" />
          ניקוי סינונים
        </a>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="table table-striped">
        <thead>
          <!-- Sorting buttons -->
          <tr>
            <th v-for="(column, k) in chosenColumns" :key="k" scope="col">
              <a
                class="text-dark btn"
                href="javascript:void(0)"
                @click="sortBy(column.name)"
              >
                {{ column.hebrewName }}
                <i :class="getSortIconClasses(column.name)"></i>
              </a>
            </th>
          </tr>

          <!-- Filtering inputs -->
          <tr>
            <th v-for="(column, j) in chosenColumns" :key="j" scope="col">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchKeys[column.name]"
                  :placeholder="`חיפוש ${column.hebrewName}`"
                />
              </div>
            </th>
          </tr>
        </thead>

        <!-- Table body -->
        <tbody>
          <TableRow
            v-for="(row, index) in displayedEvents"
            :key="index"
            :row="row"
            :columns="chosenColumns"
            :tableType="tableType"
          />
        </tbody>
      </table>
    </div>
    <!-- For excel export -->
    <div v-show="false" class="table-wrapper">
      <table class="excel table table-striped">
        <thead>
          <!-- Sorting buttons -->
          <tr>
            <th v-for="(column, k) in chosenColumns" :key="k" scope="col">
              <a
                class="text-dark btn"
                href="javascript:void(0)"
                @click="sortBy(column.name)"
              >
                {{ column.hebrewName }}
                <i :class="getSortIconClasses(column.name)"></i>
              </a>
            </th>
          </tr>

          <!-- Filtering inputs -->
          <tr>
            <th v-for="(column, j) in chosenColumns" :key="j" scope="col">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchKeys[column.name]"
                  :placeholder="`חיפוש ${column.hebrewName}`"
                />
              </div>
            </th>
          </tr>
        </thead>

        <!-- Table body -->
        <tbody>
          <TableRow
            v-for="(row, index) in rows"
            :key="index"
            :row="row"
            :columns="chosenColumns"
            :tableType="tableType"
          />
        </tbody>
      </table>
    </div>
    <!-- No results -->
    <div v-if="rows.length === 0" class="no-results-table center">
      <h2 class="title--32">אין תוצאות</h2>
      <div class="text">יש לנקות סינונים או לבחור טווח תאריכים אחר</div>
    </div>

    <!-- Pagination -->
    <TablePagination
      :current="currentPage + 1"
      :total="numberOfPages"
      @setPage="setPage"
    />
  </div>
</template>

<script>
import TableFiltersMobilePopup from "@/components/Popups/TableFiltersMobilePopup";
import TablePagination from "./TablePagination.vue";
import TableRow from "./TableRow.vue";
import {
  APPOINTMENT_COLUMNS,
  SURGERY_COLUMNS,
  PATHOLOGY_COLUMNS
} from "../../utilities/tables-config";
import { getTableEvents } from "../../utilities/tables-event-type";
import * as XLSX from "xlsx-js-style";

export default {
  components: { TableRow, TablePagination },
  props: {
    data: { type: Array, required: true },
    tableType: { required: true },
    isFilteringByInput: { type: Boolean, required: true },
    downloadToExcel: { type: Boolean, default: false }
  },
  data() {
    return {
      /**
       * The column we sort by.
       *
       * @type {string | null}
       */
      sort: null,
      isAscending: true,
      isShowMoreActive: false,
      /**
       * Object contains the keys of
       * searches and the value of each.
       *
       * @example { "ניתוח": "סוג" }
       */
      searchKeys: {},
      /**
       * All the available columns
       * for the table
       */
      columns: [],
      /**
       * Holds array of the columns
       * shown to the user. Starts with
       * the same value as @var columns
       */
      chosenColumns: [],
      /**
       * Stores a reference of all the
       * columns marked as default.
       */
      defaultColumns: [],
      /**
       * @readonly eventsPerPage Number to rely
       * on for pagination. All calculations
       * depends on that.
       */
      eventsPerPage: 10,
      currentPage: 0
    };
  },
  created() {
    this.initializeComponent();
  },
  computed: {
    /**
     * Taking the events getting passed
     * from props, and converting them to
     * an object the table can read.
     */
    tableEvents() {
      if (this.isFilteringByInput) {
        return getTableEvents(this.data, this.tableType, "search");
      }
      let events = getTableEvents(this.data, this.tableType);
      // default sort for pathology list
      if (this.tableType == "pathology" && !this.sort) {
        events = events.sort(
          (a, b) =>
            this.$moment(b.created_at, "DD-MM-YYYY").format("YYYYMMDD") -
            this.$moment(a.created_at, "DD-MM-YYYY").format("YYYYMMDD")
        );
        events = events.sort((a, b) => a.view_count - b.view_count);
      }
      return events;
    },
    /**
     * @returns {object[]} The rows of the table
     * after searching + filtering + sorting.
     *
     * Object structure can be found in tableEvents
     * function, according to tableType prop.
     */
    rows() {
      /// Searching
      const keys = Object.keys(this.searchKeys);
      let result = {};
      keys.forEach(key => {
        const searchString = this.searchKeys[key];
        if (!searchString) return;
        result[key] = this.createSearchFuncs(searchString);
      });
      /// Filtering
      const searchedCols = Object.keys(result);
      const rows = this.tableEvents.filter(row => {
        return !searchedCols.some(col => {
          if (col === "patient_view_status") {
            const val1 = row.located_report;
            const val2 = row.viewed_by_patient > 0 ? "צפה" : "לא צפה";
            return !result[col](val1) && !result[col](val2);
          }
          const colVal = row[col];
          return !result[col](colVal);
        });
      });
      this.setLocalStorage();
      if (this.sort === null) return rows;
      /// Sorting
      const col = this.sort;
      if (col === "created_at") {
        rows.sort((a, b) => {
          const aDate = this.$moment(a[col], "DD-MM-YYYY");
          const bDate = this.$moment(b[col], "DD-MM-YYYY");
          return this.isAscending ? aDate - bDate : bDate - aDate;
        });
      } else {
        if (this.isAscending) {
          rows.sort((a, b) => (a[col] > b[col]) - (a[col] < b[col]));
        } else {
          rows.sort((b, a) => (a[col] > b[col]) - (a[col] < b[col]));
        }
      }
      return rows;
    },
    /**
     * Checking if sort is active or showned
     * columns were modified or any search
     * is active.
     *
     * @returns {boolean} If we show the
     * 'clear' button on the screen.
     */
    showClearButton() {
      const searchValuesArr = [];
      for (const key in this.searchKeys) {
        if (this.searchKeys[key] === "") continue;
        searchValuesArr.push(key);
      }

      return (
        this.sort !== null ||
        this.chosenColumns.toString() !== this.defaultColumns.toString() ||
        searchValuesArr.length !== 0
      );
    },
    /**
     * The number of pages available
     * to click on by the number of the
     * events.
     *
     * @returns {number}
     */
    numberOfPages() {
      const float = this.rows.length / this.eventsPerPage;
      return Math.ceil(float);
    },
    /**
     * The events we show to the screen.
     * In case where the page is too high
     * we reset it to 1.
     *
     * @returns {Object[]}
     */
    displayedEvents() {
      const condition =
        this.numberOfPages <= this.currentPage || this.currentPage < 0;
      if (this.data.length && condition) {
        this.setPage(1);
      }

      const start = this.currentPage * this.eventsPerPage;
      let end = start + this.eventsPerPage;

      const isArrayEnd = this.rows.length < end;
      if (isArrayEnd) end = this.rows.length;

      return this.rows.slice(start, end);
    }
  },
  methods: {
    initializeComponent() {
      if (this.tableType == "appointment") this.columns = APPOINTMENT_COLUMNS;
      else if (this.tableType == "surgery") this.columns = SURGERY_COLUMNS;
      else this.columns = PATHOLOGY_COLUMNS;
      this.defaultColumns = this.columns.filter(c => c.isDefault);
      this.chosenColumns = [...this.defaultColumns];

      if (window.location.hash.includes("page")) {
        const pageNumber = window.location.hash.replace("#&page=", "");
        const parsedNumber = parseInt(pageNumber); // -> can be NaN

        if (typeof parsedNumber === "number") this.setPage(parsedNumber);
        else window.location.hash = "";
      }

      this.getInitialFilters();
    },
    /**
     * Sets the page to view and change
     * the hash according to it.
     *
     * @param {number} pageNumber
     */
    setPage(pageNumber) {
      this.currentPage = pageNumber - 1;
      window.location.hash = `&page=${pageNumber}`;
    },
    /**
     * Setting the sorting by a column.
     *
     * @param {string} column
     */
    sortBy(column) {
      if (this.sort === column) {
        this.isAscending = !this.isAscending;
        return;
      }
      this.sort = column;
      this.isAscending = true;
    },
    /**
     * @param {string} column
     * @returns {string[]} array of icon classes.
     */
    getSortIconClasses(column) {
      if (this.sort !== column) return ["fas", "fa-sort"];
      if (this.isAscending === true) return ["fas", "fa-sort-up"];
      return ["fas", "fa-sort-down"];
    },
    /**
     * Creating a function to push into
     * searchKeys for each search column.
     *
     * The function it creates will handle
     * the search for each column input.
     *
     * @param {string} search
     * @returns {Function} search function.
     */
    createSearchFuncs(search) {
      const val = search.toLowerCase();
      return input => {
        if (!input) return false;
        input = input.toString().toLowerCase();
        return input.includes(val);
      };
    },
    /**
     * Removing a visible column if it
     * exists. If not, inserting it in the
     * position it was before.
     *
     * @param {String} columnName
     */
    toggleColumn(columnName) {
      const index = this.chosenColumns.findIndex(c => c.name === columnName);
      if (index !== -1) {
        this.chosenColumns.splice(index, 1);
        return;
      }
      const existsColIndex = this.columns.findIndex(c => c.name === columnName);
      this.chosenColumns.push(this.columns[existsColIndex]);

      const sortedArr = this.columns.filter(col => {
        return this.chosenColumns.some(c => c.id == col.id);
      });

      this.chosenColumns = sortedArr;

      this.setLocalStorage();
    },
    /**
     * Getting if a filter is chosen or not.
     *
     * @param {String} columnName
     * @returns {Boolean}
     */
    getIsColumnActive(columnName) {
      const found = this.chosenColumns.find(c => c.name === columnName);
      return found !== undefined;
    },
    /**
     * Function made for mobile, passing it
     * to the mobile filters popup and setting
     * all chosen filters from the popup  at once
     *
     * @param {String[]} columns
     */
    setShownedColumns(columns = []) {
      this.chosenColumns = [...columns];
      this.setLocalStorage();
    },
    /**
     * Saving any change in filters
     * that user made.
     */
    setLocalStorage() {
      const storageObj = {
        sort: this.sort,
        isAscending: this.isAscending,
        searchKeys: this.searchKeys,
        showenTableColumns: this.chosenColumns,
        tableType: this.tableType
      };
      localStorage.setItem("search-values", JSON.stringify(storageObj));
    },
    /**
     * Runs in created function.
     * Getting values from local storage
     * and setting them initially.
     */
    getInitialFilters() {
      const storageObj = localStorage.getItem("search-values");
      if (!storageObj) return;
      const parsedObj = JSON.parse(storageObj);
      if (parsedObj.tableType !== this.tableType) {
        this.resetState();
        return;
      }
      this.sort = parsedObj.sort;
      this.isAscending = parsedObj.isAscending;
      this.searchKeys = parsedObj.searchKeys;
      this.chosenColumns = parsedObj.showenTableColumns ?? [...this.columns];
    },
    /**
     * Resetting all filters state.
     */
    resetState() {
      this.sort = null;
      this.isAscending = true;
      this.searchKeys = {};
      this.chosenColumns = [...this.defaultColumns];
      localStorage.removeItem("search-values");
    },
    /**
     * Function made for mobile only
     */
    openFiltersPopup() {
      this.$modal.show(TableFiltersMobilePopup, {
        columns: this.columns,
        showenTableColumns: this.chosenColumns,
        setShownedColumns: this.setShownedColumns
      });
    },
    exportToExcel() {
      // Create a worksheet from the table data
      const table_elt = document.querySelector(".excel");
      const ws = XLSX.utils.table_to_sheet(table_elt, { raw: true });

      ws["!cols"] = this.chosenColumns.map(c => {
        return { wch: 20 };
      });

      for (const key in ws) {
        const res = key.replace(/\D/g, "");
        if (res == 1) {
          ws[key].s = {
            font: {
              sz: 12,
              bold: true,
              color: { rgb: "324997" }
            }
          };
        }
      }

      // const wb = XLSX.utils.book_new();
      const wb = {
        Workbook: { Views: [{ RTL: true }] },
        Sheets: {},
        SheetNames: []
      };
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // Save the Excel file
      XLSX.writeFile(wb, "table_data.xlsx");
    }
  },
  watch: {
    data() {
      this.setLocalStorage();
    },
    $route(to, from) {
      if (to.params.type == from.params.type) return;
      this.initializeComponent();
      this.resetState();
    },
    downloadToExcel(value) {
      if (value) this.exportToExcel();
    }
  }
};
</script>
